export default {
  404: 'No hay registros',
};
